import { Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { PaymentDetailDialogComponent, PaymentDetailDialogInput } from '../../../shared/payment-detail-dialog/payment-detail-dialog.component';
import { PaymentGroup } from '../../../../../models/entities/payment-group';
import { JwtLegFiClaims } from '../../../../../services/auth/jwt-legfi-claims.model';
import { Router } from '@angular/router';
import { PaymentGroupsService } from '../../../../../services/payment/payment-groups.service';
import { LegFiJwtService } from '../../../../../services/auth/legfi-jwt.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SingleDateRangeFilter } from '../../../shared/report-filters/single-date-range/single-date-range-filter';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PaymentsTableComponent } from '../../../payments/incoming-payments/payments-table/payments-table.component';
import { PaymentsDatasource } from '../../../../../services/payment/payments.datasource';
import { SelectionModel } from '@angular/cdk/collections';
import { MaterialSearchComponent } from '../../../../shared/material-search/material-search.component';
import { SingleDateRangeComponent } from '../../../shared/report-filters/single-date-range/single-date-range.component';
import { RequestDate } from 'app/components/shared/http/request-interfaces';

@UntilDestroy()
@Component({
    selector: 'app-dash-payments',
    templateUrl: './dash-payments.component.html',
    styleUrls: ['./dash-payments.component.scss'],
})
export class DashPaymentsComponent implements OnInit
{
    @HostBinding('class.card') card = true;
    @HostBinding('class.card-set-height') cardSetHeight = true;
    filters: SingleDateRangeFilter;

    @ViewChild('searchInput') searchInput: MaterialSearchComponent;

    @ViewChild('dateFilter') dateFilter: SingleDateRangeComponent;

    @ViewChild('paymentsTable') paymentsTable: PaymentsTableComponent;
    tableDataSource: PaymentsDatasource;
    selectedPayments: SelectionModel<PaymentGroup> = new SelectionModel<PaymentGroup>(true);
    totalRecords: number = 0;
    renderedData: PaymentGroup[];

    jwt: JwtLegFiClaims = null;

    hasWriteAccess = false;
    isFiltersLoaded = false;

    constructor(
            private _paymentGroupsService: PaymentGroupsService,
            private _router: Router,
            private _dialog: MatDialog,
    ) {

    }

    ngOnInit(): void {
        this.jwt = LegFiJwtService.read();

        this.hasWriteAccess = LegFiJwtService.doesUserHaveModulePermission(
                'payments',
                true,
        );

        this.tableDataSource = new PaymentsDatasource(this._paymentGroupsService);

        this.tableDataSource.count$.pipe(untilDestroyed(this)).subscribe(
                (count) => {
                    this.totalRecords = count;
                },
        );

        this.tableDataSource.connect().pipe(untilDestroyed(this)).subscribe({
            next: (data) => {
                this.renderedData = data;
                this.selectedPayments = new SelectionModel<PaymentGroup>(true, []);
            },
        });

        if (this.jwt !== null) {
            if (this.jwt.superUser || this.jwt.admin) {
                this.hasWriteAccess = true;
            }
        }
    }

    showPaymentDetail(payment: PaymentGroup) {
        this._dialog.open(PaymentDetailDialogComponent, {
            data: <PaymentDetailDialogInput>{
                paymentGroupId: payment.id,
            },
        });
    }

    filtersLoaded() {
        this.isFiltersLoaded = true;
        this.getIncomingPayments();
    }

    getIncomingPayments(): void {
        this.tableDataSource.loadPayments(
                null,
                {
                    search: this.searchInput.searchValue,
                    column: this.paymentsTable.sort.active,
                    direction: this.paymentsTable.sort.direction,
                    page: this.paymentsTable.matPaginator.pageIndex + 1,
                    perPage: this.paymentsTable.matPaginator.pageSize,
                    filters: {
                        time: -1,
                        start: <RequestDate>this.dateFilter.filters.startDate.format('YYYY-MM-DD'),
                        end: <RequestDate>this.dateFilter.filters.endDate.format('YYYY-MM-DD'),
                    },
                },
        );
    }

    navigate(routerLink: any[]) {
        // noinspection JSIgnoredPromiseFromCall
        this._router.navigate(routerLink);
    }

}
